var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThemesActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9048 10.258L11.6315 1L1.66271 10.9524C1.23793 11.385 1 11.9667 1 12.5725C1 13.1784 1.23793 13.76 1.66271 14.1927L7.69034 20.2104C8.61767 21.1362 10.0087 21.1362 10.936 20.2104L20.9048 10.258Z",
    fill: "#3361CF",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4603 12.5722L11.5635 12.5722L3.61905 12.5234H1C1 13.1293 1.23793 13.7597 1.66271 14.1923L7.69034 20.2101C8.61767 21.1359 10.0087 21.1359 10.936 20.2101L18.4603 12.5722Z",
    fill: "white",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9998 20.8469C22.9998 21.418 22.7699 21.9658 22.3606 22.3696C21.9513 22.7735 21.3962 23.0004 20.8173 23.0004C20.2385 23.0004 19.6833 22.7735 19.274 22.3696C18.8647 21.9658 18.6348 21.418 18.6348 20.8469C18.6348 19.1242 20.4899 18.2628 20.8173 16.54C21.1447 18.2628 22.9998 19.1242 22.9998 20.8469Z",
    fill: "#3361CF",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemesActive);
export default __webpack_public_path__ + "static/media/themes_active.01bbf555c8d0ef42a73585e18997fcc3.svg";
export { ForwardRef as ReactComponent };